import { Image, View } from "@aws-amplify/ui-react";
import { useMediaQuery } from "@mui/material";
import { images } from "constants/index";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

export default function Ehr() {
  const matches = useMediaQuery("(min-width:900px)");
  const wmatches = useMediaQuery("(min-width:1100px)");
  const navigation = useNavigate();
  return (
    // bg-stone-800

    <View className="relative flex flex-col p-10  w-[100vw] ">
      <View
        className="relative flex pt-10  
      "
      >
        {/* EHR is.. */}
        <View
          display={matches ? "" : "none"}
          className="relative flex flex-col w-[60%] pr-8"
        >
          <div className=" font-extrabold text-[45px] text-white font-lolita-one">
            Environmental Hood Restoration (EHR)
          </div>
          <div className=" font-normal text-[25px] text-white pt-8 p-5 font-lolita-one">
            is an organization created by the community for the community with
            the primary purpose to feed, repair, clean, restore and give back to
            our neighborhood of East Flatbush, Brooklyn.
          </div>

          <View className="relative flex w-full justify-end">
            <div
              onClick={() => {
                navigation("/LearnMore");
              }}
              className="relative flex justify-center items-center w-[100px] h-[50px] mt-5 border-white border-[1px] hover:bg-[rgba(0,0,0,.4)] hover:shadow-xl hover: cursor-pointer rounded-sm font-lolita-one"
            >
              <div className=" text-white">Learn More</div>
            </div>
          </View>
        </View>
        {/* We are ... */}
        {/* <motion.div
          initial={{
            marginRight: "500px",
            opacity: 0.2,
            // scale: 0.2,
          }}
          whileInView={{
            marginRight: "0px",
            opacity: 1,
            // scale: 1,
          }}
          exit={{
            marginRight: "800px",
          }}
          transition={{
            duration: 2,
            type: "tween",
          }}
        > */}
        <View
          className={`relative flex  ${
            matches ? "w-[500px]" : ""
          }  gap-5 bg-[rgba(41,46,41,0.4)] h-auto flex-wrap`}
        >
          <div className=" relative flex  p-5 font-medium text-white  min-w-[300px] font-lolita-one">
            We are committed to empowering our youth (ages 5 - 17) in every way
            as they transition from adolescence to adulthood via education and
            tangible life-skill building, including leadership, teamwork,
            responsibility, integrity, respect, accountability, and compassion.
          </div>

          <Image
            objectFit="cover"
            width="500px"
            height="400px"
            alt=""
            src={images.sk19}
          />
        </View>
        {/* </motion.div> */}
      </View>

      <View className="relative flex gap-10">
        <View className="relative flex w-[45%]  mt-5 ">
          <Image
            objectFit="cover"
            width={300}
            height={400}
            alt=""
            src={images.sk7}
          />
          <View className="relative  pl-5 pr-3">
            <motion.div
              initial={{
                opacity: 0.3,
                scale: 0.8,
              }}
              whileInView={{
                opacity: 1,
                scale: 1,
              }}
              transition={{ duration: 2 }}
            >
              <div className=" font-bold text-[30px]  text-white font-lolita-one">
                We do this through a multilateral approach
              </div>

              <div className="font-semibold text-[15px]  text-white font-lolita-one">
                This includes an active lifestyle such as basketball and
                skating, as well as feeding the 90z community through food
                drives and fridges.
              </div>
            </motion.div>
          </View>
        </View>

        <View
          display={wmatches ? "" : "none"}
          className="relative flex  w-[55%] pt-10"
        >
          <>
            <Image
              objectFit="cover"
              width={"50%"}
              height=""
              alt=""
              src={images.sk10}
            />
            <View className="p-5">
              <motion.div
                initial={{
                  opacity: 0.3,
                  scale: 0.8,
                }}
                whileInView={{
                  opacity: 1,
                  scale: 1,
                }}
                transition={{ duration: 2 }}
              >
                <div className="font-semibold text-[15px] text-white font-lolita-one">
                  <div className=" font-bold text-[25px]  text-white">
                    EHR repairs damages caused by challenges because of the
                    wealthgap and inequality
                  </div>
                  Dedicated to neighborhood development and public safety, EHR
                  centers community organizing from within to create
                  sustainable, systemic change.
                </div>
              </motion.div>
            </View>
          </>
        </View>
      </View>

      <View display={matches ? "none" : ""}>
        <div
          onClick={() => {
            navigation("/LearnMore");
          }}
          className="relative flex  justify-center items-center w-[100px] h-[50px] mt-4 border-white border-[1px] hover:bg-[rgba(0,0,0,.4)] hover:shadow-xl hover: cursor-pointer rounded-sm"
        >
          <div className=" text-white">Learn More</div>
        </div>
      </View>
    </View>
  );
}
